export const SOFTLINE_MODULE_WWS_DELIVERY_NOTE_CORRECTION =
  'wws-delivery-note-correction';
// Keep in sync with the literal in src/federation/module-metadata.ts.
export const SOFTLINE_PERMISSION_WWS_DELIVERY_NOTE_CORRECTION =
  'ROLE_DELIVERY_NOTE_CORRECTION';
/** Root path of the module's route tree (`routePrefixes.app` in the federation metadata). */
export const SOFTLINE_ROUTE_WWS_DELIVERY_NOTE_CORRECTION = 'delivery-note-correction';
